import React, { useEffect } from 'react';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { Language } from './Constants/Language';
import { OidcConfiguration } from './Authentication/Configuration';
import { AuthenticationProvider, oidcLog, useReactOidc } from '@axa-fr/react-oidc-context';
import { Routes } from './Layout/Routes';
import { setAuthorizationHeader } from './Authentication/TokenManagerUtility';
import { overridetheme } from './Theme/themeConfig';
import {
	Box,
	Button,
	ChakraProvider,
	Container,
	Flex,
	Heading,
	Image,
	Skeleton,
	Text
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { pages } from './Constants/Pages';

const App = () => {
	const { t, i18n } = useTranslation('calendar');
	const changeLanguage = (lang: Language) => i18n.changeLanguage(lang);
	const language = i18n.language;

	// set page title before loading app
	document.title = t('Omahallinta');

	return (
		<AuthenticationProvider
			configuration={{
				...OidcConfiguration
				// stateStore: new WebStorageStateStore()
			}}
			logger={oidcLog}
			notAuthenticated={() => <div></div>}
			authenticating={() => <div></div>}
			callbackComponentOverride={(props) => {
				console.log(props);
				// alert('callback called');
				return <Skeleton p={8}></Skeleton>;
			}}
		>
			<AuthEventHandler />
			<ChakraProvider theme={overridetheme}>
				<BrowserRouter basename={process.env.REACT_APP_BASEPATH}>
					{/* Sivutus */}
					<Box as="main" shadow="inner" bg="gray.50" minH="100vh">
						<Box
							bg="gray.800"
							color="gray.100"
							p={4}
							alignItems="center"
							d="flex"
							justifyContent="space-between"
						>
							<Heading as="h2" fontSize="lg">
								{t('Omahallinta')}
							</Heading>
							<Flex justify="center" align="center">
								<Button
									p={0}
									mr={2}
									borderRadius="full"
									onClick={() => changeLanguage(Language.fi)}
									disabled={language === Language.fi}
									variant="ghost"
									aria-label="Change language to finnish"
								>
									<Image width={8} height={8} src="fin.png" alt="FIN"></Image>
								</Button>

								{/* <Button
									p={0}
									mr={2}
									borderRadius="full"
									onClick={() => changeLanguage(Language.en)}
									disabled={language === Language.en}
									variant="ghost"
									aria-label="Change language to english"
								>
									<Image width={8} height={8} src="eng.png" alt="ENG"></Image>
								</Button>

								<Button
									p={0}
									mr={2}
									borderRadius="full"
									onClick={() => changeLanguage(Language.swe)}
									disabled={language === Language.swe}
									variant="ghost"
									aria-label="Change language to swedish"
								>
									<Image width={8} height={8} src="swe.png" alt="SWE"></Image>
								</Button> */}
								<SignOutActions />
							</Flex>
						</Box>
						<Box p={4}>
							<Container p={4} shadow="md" bg="white" maxW="88rem">
								<Routes />
							</Container>
						</Box>
					</Box>
					{/* </Grid> */}
				</BrowserRouter>
			</ChakraProvider>
		</AuthenticationProvider>
	);
};

// TODO: move to separate file
// TODO: refactor lang buttons to separate file
const SignOutActions = () => {
	const { logout, oidcUser } = useReactOidc();
	const history = useHistory();
	const { t } = useTranslation('common');

	const handleLogOut = () => logout();

	// services is protected page, trying to move there moves us to login.
	const handleLogin = () => history.push(pages.services);

	return oidcUser ? (
		<Flex justify="center" align="center">
			<Text px={3}>{oidcUser.profile.name}</Text>
			<Button onClick={handleLogOut} type="button">
				{t('Kirjaudu ulos')}
			</Button>
		</Flex>
	) : (
		<Button onClick={handleLogin} type="button">
			{t('Kirjaudu sisään')}
		</Button>
	);
};

// TODO: move to authentication folder
const AuthEventHandler = () => {
	const { oidcUser } = useReactOidc();
	const token: string | undefined = oidcUser?.access_token;

	useEffect(() => {
		token && setAuthorizationHeader(token);

		// console.log({
		// 	token: token,
		// 	originalUserManager: getUserManager(),
		// 	originalSettings: getUserManager().settings
		// });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	return null;
};

export default App;
